// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { curveSet } from './initialValues'

const assignEmptyCurveSets = curveSets => {
  Object.values(curveSets).forEach(d => {
    if (!d.length) {
      d.push(...curveSet)
    }
  })
}

export default assignEmptyCurveSets
